import { RootStateOrAny, useSelector } from 'react-redux';

export function useShowShoppingBagLoadingIndicator() {
  const isLoadingRow = useSelector(
    (state: RootStateOrAny) =>
      state.shoppingBag?.updatingCartDrawerItem ||
      state.shoppingBag?.deletingCartDrawerItem
  );
  // @ts-ignore
  const { loading } = useSelector(state => state.checkout);

  // when updating/deleting an item, don't show the overall loading indicator
  // since we want to avoid showing both at the same time.
  return { showLoadingIndicator: loading && !isLoadingRow };
}
